import { Icon, Tooltip } from "@components/library";
import { COLORS, FONTS } from "@constants";
import { ReactNode } from "react";
import styled from "styled-components";
interface Props {
  children: number | string | ReactNode;
  marginLeft?: string;
  accent?: boolean;
  backgroundColor?: string;
  textColor?: string;
  "data-testid"?: string;
  tooltipText?: string;
}

const InfoTag = ({
  children,
  marginLeft = "12px",
  accent = false,
  backgroundColor,
  textColor,
  "data-testid": dataTestId,
  tooltipText,
}: Props) => {
  return tooltipText ? (
    <Tooltip
      content={tooltipText}
      position="right"
      asPortal
      tooltipWidth="250px"
      arrowOffsetTop="35px"
    >
      <Container
        marginLeft={marginLeft}
        accent={accent}
        backgroundColor={backgroundColor}
        textColor={textColor}
        data-testid={dataTestId}
      >
        {children}
        {tooltipText && (
          <IconWrapper className="info-icon">
            <Icon name="Info Inverted" size="sm" color={COLORS.BLUE_450} />
          </IconWrapper>
        )}
      </Container>
    </Tooltip>
  ) : (
    <Container
      marginLeft={marginLeft}
      accent={accent}
      backgroundColor={backgroundColor}
      textColor={textColor}
      data-testid={dataTestId}
    >
      {children}
    </Container>
  );
};

export default InfoTag;

const Container = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 18px;
  min-width: 20px;
  width: auto;
  background: ${({ accent, backgroundColor }) =>
    backgroundColor || (accent && COLORS.BLUE_GRADIENT) || COLORS.NEUTRAL_400};
  color: ${({ textColor }) => textColor || COLORS.WHITE};
  border-radius: 100px;
  padding: ${({ accent }) => (accent ? "2px 8px" : "2px 6px")};
  margin-left: ${({ marginLeft }) => marginLeft};
  ${({ accent }) => (accent ? FONTS.TAG_ACCENT : FONTS.TAG_BOLD_2)};
`;
const IconWrapper = styled.span`
  opacity: 0.5;
  margin-right: -6px;
`;
